const base_url = 'https://app.cannacabana.com'
let signupState = {
  input: '',
  isEmail: false,
  masked: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  postalCode: '',
  dob: '',
  otpToken: ''
};
/**
 * Fail-safe OTP handler
 */
function handleOtpInput(el) {
  // 1. Find the container and all inputs inside it
  const container = el.closest('.code-input-group');
  const inputs = Array.from(container.querySelectorAll('input'));
  const currentStep = el.closest('.cabana-step');
  const continueBtn = currentStep.querySelector('button.cabana-btn');

  // 2. Force numeric, store real digit, and show "X"
  const digit = el.value.replace(/\D/g, '').slice(-1);
  el.dataset.digit = digit || '';
  el.value = digit ? 'X' : '';

  const currentIndex = inputs.indexOf(el);
  if (digit && currentIndex < inputs.length - 1) {
    // On some mobile browsers, focus needs a tick to move reliably
    const nextInput = inputs[currentIndex + 1];
    if (nextInput) {
      setTimeout(() => nextInput.focus(), 0);
    }
  }

  // 3. Check if all are filled
  const code = inputs.map(i => i.dataset.digit || '').join('');
  console.log("Current OTP entered:", code); // Debugging

  if (code.length === 4) {
    if (continueBtn) {
      continueBtn.disabled = false;
      continueBtn.classList.remove('disabled');
      console.log("OTP Complete. Button Enabled.");
    }
  } else {
    if (continueBtn) {
      continueBtn.disabled = true;
      continueBtn.classList.add('disabled');
    }
  }
}

async function getAccessToken() {
  const stored = localStorage.getItem('canna_access_token');
  const expiry = localStorage.getItem('canna_access_token_expiry');

  if (stored && expiry && Date.now() < Number(expiry)) {
    return stored;
  }

  const response = await fetch(`${base_url}/oauth/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      client_id: '7',
      client_secret: 'dqo3pUrSPyN0ONslDAzw1oHaxXs5KZ3D38DcNqLa',
      grant_type: 'client_credentials',
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to retrieve access token');
  }

  const data = await response.json();

  localStorage.setItem('canna_access_token', data.access_token);
  localStorage.setItem(
    'canna_access_token_expiry',
    Date.now() + data.expires_in * 1000
  );

  return data.access_token;
}

/**
 * Call forgot-password API (used by Elite recover flow and any other recover UI).
 * Returns { success, message } or throws.
 */
window.recoverPasswordForgot = async function (email) {
  const accessToken = await getAccessToken();
  const formData = new FormData();
  formData.append('email', email);
  const res = await fetch(`${base_url}/api/shopify-auth/forgot-password`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${accessToken}`, 'Accept': 'application/json' },
    body: formData
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || 'Failed to send recovery email.');
  return data;
};

function openCabanaPopup() {
  window.isEliteFlow = false;
  document.getElementById('cabana-popup').style.display = 'flex';
  switchToStep(1);
}

/**
 * Open Cabana sign-up popup at Step 2 (profile) with email/phone pre-filled.
 * Used when user clicks Log in, enters email/phone, and check-customer returns "not found"
 * so we skip Step 1 (check again) and go straight to sign-up profile.
 */
function openCabanaPopupAtStep2(emailOrPhone) {
  if (!emailOrPhone || !emailOrPhone.trim()) return;
  window.isEliteFlow = false;
  const input = emailOrPhone.trim();
  signupState.input = input;
  signupState.isEmail = input.includes('@');
  // Pre-fill step 1 input for consistency (e.g. resend/verify later)
  const userInputEl = document.getElementById('userInput');
  if (userInputEl) userInputEl.value = input;
  // Pre-fill step 2 profile fields
  const regEmail = document.getElementById('reg-email');
  const regPhone = document.getElementById('reg-phone');
  if (signupState.isEmail && regEmail) {
    regEmail.value = input;
  } else if (regPhone) {
    regPhone.value = input.replace(/\D/g, '').slice(-10);
  }
  const popup = document.getElementById('cabana-popup');
  if (popup) popup.style.display = 'flex';
  const emailErr = document.getElementById('email-error');
  if (emailErr) emailErr.textContent = '';
  const profileErr = document.getElementById('profile-error');
  if (profileErr) profileErr.textContent = '';
  switchToStep(2);
}
if (typeof window !== 'undefined') {
  window.openCabanaPopupAtStep2 = openCabanaPopupAtStep2;
}

function closeCabanaPopup() {
  // Hide popup
  const popup = document.getElementById('cabana-popup');
  if (popup) {
    popup.style.display = 'none';
  }

  // Fully reset signup state and UI so next open starts fresh
  try {
    // Reset state object
    signupState = {
      input: '',
      isEmail: false,
      masked: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      postalCode: '',
      dob: '',
      otpToken: ''
    };

    // Clear text inputs used across steps
    const fieldIds = [
      'userInput',
      'reg-first-name',
      'reg-last-name',
      'reg-email',
      'reg-phone',
      'reg-postal',
      'reg-dob'
    ];
    fieldIds.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });

    // Clear OTP inputs
    document.querySelectorAll('.code-input-group input').forEach(input => {
      input.value = '';
      input.dataset.digit = '';
    });

    // Clear error/success messages
    ['method-error', 'otp-error', 'elite-otp-error', 'signup-error'].forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.textContent = '';
        el.innerHTML = '';
      }
    });

    // Reset buttons to initial disabled/enabled state
    const otpBtn = document.getElementById('otp-continue-btn');
    if (otpBtn) {
      otpBtn.disabled = true;
      otpBtn.classList.add('disabled');
    }
    const eliteOtpBtn = document.getElementById('elite-otp-continue');
    if (eliteOtpBtn) {
      eliteOtpBtn.disabled = true;
      eliteOtpBtn.classList.add('disabled');
    }

    const sendCodeBtn = document.getElementById('send-code-btn');
    if (sendCodeBtn) {
      sendCodeBtn.disabled = false;
    }

    // Reset resend link and timer
    if (typeof resendTimer !== 'undefined' && resendTimer) {
      clearInterval(resendTimer);
    }
    const resendLink = document.querySelector('.resend-link a');
    if (resendLink) {
      resendLink.textContent = 'Resend Code';
      resendLink.classList.remove('disabled');
      resendLink.style.pointerEvents = 'auto';
    }

    // Go back to first step when reopened
    switchToStep(1);
  } catch (e) {
    console.error('Error resetting signup popup state', e);
  }
}

function switchToStep(stepNumber) {
  const steps = document.querySelectorAll('.cabana-step');
  steps.forEach(step => step.style.display = 'none');
  const target = document.getElementById(`step-${stepNumber}`);
  if (target) {
    target.style.display = 'block';
    // Ensure Step 2 button says "Continue"
    if (stepNumber === 2) {
      const btn = target.querySelector('.signup-submit-btn');
      if (btn) btn.textContent = "Continue";
    }
  }
}
async function goToStep(stepNumber) {
  const inputEl = document.getElementById('userInput');
  const input = inputEl?.value?.trim();
  if (stepNumber === 2) {
    const btn = document.getElementById('step1-continue-btn');
    if (!input) {
      if (inputEl) inputEl.classList.add('cabana-field-error');
      displayError('email-error', 'Required.');
      return;
    }

    // Clear previous error
    if (inputEl) inputEl.classList.remove('cabana-field-error');
    clearError('email-error');

    const isEmailInput = input.includes('@');
    if (isEmailInput) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input)) {
        if (inputEl) inputEl.classList.add('cabana-field-error');
        displayError('email-error', 'Please enter a valid email.');
        return;
      }
    } else {
      const digits = input.replace(/\D/g, '');
      if (digits.length < 10) {
        if (inputEl) inputEl.classList.add('cabana-field-error');
        displayError('email-error', 'Please enter a valid email or phone number.');
        return;
      }
    }
    showLoader();
    setButtonLoading(btn, true);
    try {
      const normalizedInput = normalizeCheckCustomerIdentifier(input);
      const accessToken = await getAccessToken();
      const res = await fetch(`${base_url}/api/shopify-auth/check-customer`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: normalizedInput })
      });
      const data = await res.json();

      if (data?.data?.is_exists) {
        // Existing customer: for Elite flow, send them to login modal instead of error
        if (window.isEliteFlow) {
          try {
            const elitePopup = document.getElementById('elite-popup');
            if (elitePopup) {
              elitePopup.style.display = 'none';
            }
            const accountModal = document.querySelector('customer-account-modal');
            if (accountModal && typeof accountModal.openModal === 'function') {
              accountModal.openModal('login');
            }
          } catch (err) {
            console.error('Error opening login modal for existing Elite customer:', err);
          }
        } else {
          displayError('email-error', 'User already exists.');
        }
        return;
      }

      // Pre-fill Profile screen based on what they typed in Step 1
      signupState.input = normalizedInput;
      signupState.isEmail = normalizedInput.includes('@');

      if (signupState.isEmail) {
        document.getElementById('reg-email').value = normalizedInput;
      } else {
        document.getElementById('reg-phone').value = normalizedInput.replace(/\D/g, '').slice(-10);
      }

      switchToStep(2); // Show the Profile Screen (the one in your image)
    } catch (e) {
      displayError('email-error', 'Error checking user.');
    } finally {
      hideLoader();
      setButtonLoading(btn, false);
    }
    return;
  }
  switchToStep(stepNumber);
}

function maskEmail(email) {
  const [user, domain] = email.split("@");
  const maskedUser = user.length > 2 ? user.slice(0, 2) + "******" : user[0] + "******";
  return `${maskedUser}@${domain}`;
}

function maskPhone(phone) {
  const clean = phone.replace(/\D/g, '');
  const last4 = clean.slice(-4);
  return `*** *** ${last4}`;
}

function normalizeCheckCustomerIdentifier(value) {
  const raw = (value || '').trim();
  if (!raw) return '';
  if (raw.includes('@')) return raw;

  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  if (raw.startsWith('+') && digits.length >= 11) return `+${digits}`;
  return raw;
}

function clearFieldError(inputEl) {
  if (!inputEl) return;
  inputEl.classList.remove('cabana-field-error');
  const host = inputEl.closest('label') || inputEl.parentElement;
  if (!host) return;
  const inlineErr = host.querySelector('.cabana-inline-error');
  if (inlineErr) inlineErr.remove();
}

function setFieldError(inputEl, message) {
  if (!inputEl) return;
  clearFieldError(inputEl);
  inputEl.classList.add('cabana-field-error');
  const host = inputEl.closest('label') || inputEl.parentElement;
  if (!host) return;
  const err = document.createElement('div');
  err.className = 'cabana-inline-error error-msg';
  err.style.color = '#ff6b6b';
  err.style.fontSize = '14px';
  err.style.marginTop = '4px';
  err.textContent = message;
  host.appendChild(err);
}

function togglePass(id) {
  const input = document.getElementById(id);
  if (!input) return;

  const isPassword = input.type === "password";
  input.type = isPassword ? "text" : "password";

  // Toggle visual state and label: "Show" when password hidden, "Hide" when visible
  const buttons = document.querySelectorAll(
    `.hide-toggle[onclick*="'${id}'"]`
  );
  buttons.forEach((btn) => {
    const span = btn.querySelector("span");
    if (isPassword) {
      btn.classList.add("hide-toggle--active");
      if (span) span.textContent = "Hide";
    } else {
      btn.classList.remove("hide-toggle--active");
      if (span) span.textContent = "Show";
    }
  });
}

// Helper: set loading state on a button
function setButtonLoading(btn, isLoading) {
  if (!btn) return;
  if (isLoading) {
    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent;
    }
    btn.classList.add('btn-loading');
    btn.disabled = true;
  } else {
    btn.classList.remove('btn-loading');
    if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
    }
    btn.disabled = false;
  }
}

async function checkCustomerEmail(input) {
  showLoader();
  clearError('email-error');

  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);
  signupState.input = input;
  signupState.isEmail = isEmail;

  const inputEl = document.getElementById('userInput');

  if (input.includes('@')) {
    if (!isEmail) {
      hideLoader();
      if (inputEl) inputEl.classList.add('cabana-field-error');
      displayError('email-error', 'Please enter a valid email.');
      return;
    }
  } else {
    const digits = input.replace(/\D/g, '');
    if (digits.length < 10) {
      hideLoader();
      if (inputEl) inputEl.classList.add('cabana-field-error');
      displayError('email-error', 'Please enter a valid email or phone number.');
      return;
    }
  }

  if (inputEl) inputEl.classList.remove('cabana-field-error');

  signupState.masked = isEmail ? maskEmail(input) : maskPhone(input);

  try {
    const accessToken = await getAccessToken();

    const response = await fetch(`${base_url}/api/shopify-auth/check-customer`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: normalizeCheckCustomerIdentifier(input) })
    });

    const data = await response.json();

    if (data?.data?.is_exists) {
      displayError('email-error', 'This user is already registered.');
      return;
    }

    switchToStep(2);
    renderVerificationOptions();

  } catch (error) {
    console.error('API error:', error);
    displayError('email-error', 'Something went wrong. Please try again.');
  } finally {
    hideLoader();
  }
}

function isValidCanadianPhone(phone) {
  const digits = phone.replace(/\D/g, '');
  if (digits.length !== 10) return false;

  // North American Numbering Plan (NANP) validation:
  // - First digit of area code (digit 1) must be 2-9
  // - First digit of exchange code (digit 4) must be 2-9
  const areaCodeDigit = parseInt(digits.charAt(0), 10);
  const exchangeDigit = parseInt(digits.charAt(3), 10);

  if (areaCodeDigit < 2 || areaCodeDigit > 9) return false;
  if (exchangeDigit < 2 || exchangeDigit > 9) return false;

  return true;
}
window.isValidCanadianPhone = isValidCanadianPhone;

async function submitProfileInfo() {
  const firstNameInput = document.getElementById('reg-first-name');
  const lastNameInput = document.getElementById('reg-last-name');
  const emailInput = document.getElementById('reg-email');
  const phoneInput = document.getElementById('reg-phone');
  const postalInput = document.getElementById('reg-postal');
  const dobInput = document.getElementById('reg-dob');

  const firstName = firstNameInput.value.trim();
  const lastName = lastNameInput.value.trim();
  const email = emailInput.value.trim();
  const phone = phoneInput.value.trim();
  const postal = postalInput.value.trim();
  const dob = dobInput.value;

  // Clear previous error highlighting/messages
  [firstNameInput, lastNameInput, emailInput, phoneInput, postalInput, dobInput].forEach((el) => {
    if (el) clearFieldError(el);
  });

  const profileErrorEl = document.getElementById(window.isEliteFlow ? 'elite-profile-error' : 'profile-error');
  if (profileErrorEl) profileErrorEl.textContent = '';

  let hasError = false;
  if (!firstName && firstNameInput) {
    setFieldError(firstNameInput, 'First name is required.');
    hasError = true;
  }
  if (!lastName && lastNameInput) {
    setFieldError(lastNameInput, 'Last name is required.');
    hasError = true;
  }
  if (!email && emailInput) {
    setFieldError(emailInput, 'Email is required.');
    hasError = true;
  } else if (email && emailInput && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    setFieldError(emailInput, 'Please enter a valid email.');
    hasError = true;
  }
  if (!phone && phoneInput) {
    setFieldError(phoneInput, 'Phone number is required.');
    hasError = true;
  } else if (phone && phoneInput && !isValidCanadianPhone(phone)) {
    setFieldError(phoneInput, 'Please enter a valid Canadian phone number.');
    hasError = true;
  }
  if (!postal && postalInput) {
    setFieldError(postalInput, 'Postal code is required.');
    hasError = true;
  }
  if (!dob && dobInput) {
    setFieldError(dobInput, 'Date of birth is required.');
    hasError = true;
  }

  if (hasError) {
    return;
  }

  // Update State
  signupState.firstName = firstName;
  signupState.lastName = lastName;
  signupState.email = email;

  // Store phone digits only — no country code prefix
  const rawPhoneDigits = phone.replace(/\D/g, '');
  signupState.phone = rawPhoneDigits;
  signupState.postalCode = postal;
  signupState.dob = dob;

  // Persist DOB for Elite birthday validation after redirect
  try {
    if (window.isEliteFlow && dob) {
      localStorage.setItem('elite_signup_dob', dob);
    }
  } catch (e) { }

  // Decide "Mode" based on existence of email
  signupState.isEmail = email.includes('@');

  // Set UI Names for later steps
  document.getElementById('otp-welcome-name').textContent = firstName;
  const step3Name = document.getElementById('step3-welcome-name');
  if (step3Name) step3Name.textContent = firstName;
  document.getElementById('success-name').textContent = firstName;

  // CRITICAL: Calculate the mask for the current preferred method
  signupState.masked = signupState.isEmail ? maskEmail(email) : maskPhone(rawPhoneDigits);

  // Important: This makes verifyCode and sendVerificationCode work by default
  signupState.input = signupState.isEmail ? email : signupState.phone;

  // Re-check with check-customer before continuing from signup profile.
  const uiEmailInput = window.isEliteFlow
    ? (document.getElementById('elite-reg-email') || emailInput)
    : emailInput;
  const uiPhoneInput = window.isEliteFlow
    ? (document.getElementById('elite-reg-phone') || phoneInput)
    : phoneInput;
  const profileBtn = window.isEliteFlow
    ? document.getElementById('elite-profile-continue-btn')
    : document.querySelector('#step-2 .signup-submit-btn');

  showLoader();
  setButtonLoading(profileBtn, true);
  try {
    const accessToken = await getAccessToken();
    const identifierToCheck = signupState.phone || signupState.email;
    const res = await fetch(`${base_url}/api/shopify-auth/check-customer`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ email: normalizeCheckCustomerIdentifier(identifierToCheck) })
    });

    const data = await res.json().catch(() => ({}));
    const exists = data?.data?.is_exists === true || data?.data?.is_exists === 'true';
    if (exists) {
      const backendEmail = String(data?.data?.customer?.email || '').trim().toLowerCase();
      const backendPhone = normalizeCheckCustomerIdentifier(data?.data?.customer?.phone_number || '');
      const enteredEmail = String(signupState.email || '').trim().toLowerCase();
      const enteredPhone = normalizeCheckCustomerIdentifier(signupState.phone || '');

      if (enteredPhone && backendPhone && enteredPhone === backendPhone && uiPhoneInput) {
        setFieldError(uiPhoneInput, 'Phone number already taken.');
      } else if (enteredEmail && backendEmail && enteredEmail === backendEmail && uiEmailInput) {
        setFieldError(uiEmailInput, 'Email already taken.');
      } else if ((identifierToCheck || '').includes('@') && uiEmailInput) {
        setFieldError(uiEmailInput, 'Email already taken.');
      } else if (uiPhoneInput) {
        setFieldError(uiPhoneInput, 'Phone number already taken.');
      }
      return;
    }

    // Render Step 3 labels and proceed only if user does not exist.
    renderVerificationOptions();
    switchToStep(3);
  } catch (e) {
    if (profileErrorEl) {
      profileErrorEl.textContent = 'Error checking user.';
    }
  } finally {
    hideLoader();
    setButtonLoading(profileBtn, false);
  }
}

function renderVerificationOptions() {
  const emailWrap = document.getElementById("email-wrap");
  const smsWrap = document.getElementById("sms-wrap");
  const emailOpt = document.getElementById("email-option");
  const smsOpt = document.getElementById("sms-option");
  const emailVal = document.getElementById("email-display-val");
  const smsVal = document.getElementById("sms-display-val");
  const footerMethod = document.getElementById("otp-footer-method");
  const footerMasked = document.getElementById("otp-footer-masked");

  const hasEmail = !!signupState.email;
  const hasPhone = !!signupState.phone;

  // Show/hide email option
  if (emailWrap) {
    emailWrap.style.display = hasEmail ? "flex" : "none";
  }
  if (hasEmail && emailVal) {
    emailVal.textContent = maskEmail(signupState.email);
  }

  // Show/hide SMS option
  if (smsWrap) {
    smsWrap.style.display = hasPhone ? "flex" : "none";
  }
  if (hasPhone && smsVal) {
    smsVal.textContent = maskPhone(signupState.phone);
  }

  // Default selection: prefer email if present, otherwise SMS
  if (hasEmail && emailOpt) {
    emailOpt.checked = true;
  } else if (hasPhone && smsOpt) {
    smsOpt.checked = true;
  }

  // Update footer alt-method based on currently selected option
  const selectedMethod = document.querySelector('input[name="vMethod"]:checked')?.value;
  if (footerMethod && footerMasked) {
    if (selectedMethod === "sms" && hasEmail) {
      footerMethod.textContent = "email";
      footerMasked.textContent = maskEmail(signupState.email);
    } else if (selectedMethod === "email" && hasPhone) {
      footerMethod.textContent = "SMS";
      footerMasked.textContent = maskPhone(signupState.phone);
    } else if (hasEmail) {
      footerMethod.textContent = "email";
      footerMasked.textContent = maskEmail(signupState.email);
    } else if (hasPhone) {
      footerMethod.textContent = "SMS";
      footerMasked.textContent = maskPhone(signupState.phone);
    }
  }

  // When user changes selection, re-run to keep footer in sync
  if (emailOpt) {
    emailOpt.onchange = () => renderVerificationOptions();
  }
  if (smsOpt) {
    smsOpt.onchange = () => renderVerificationOptions();
  }
}


async function sendVerificationCode() {
  const method = document.querySelector('input[name="vMethod"]:checked')?.value;
  const targetValue = (method === 'sms') ? signupState.phone : signupState.email;
  const methodErrorEl = document.getElementById('method-error');
  if (methodErrorEl) methodErrorEl.textContent = '';

  showLoader();
  try {
    const btn = document.getElementById('send-code-btn');
    setButtonLoading(btn, true);
    const accessToken = await getAccessToken();
    const res = await fetch(`${base_url}/api/shopify-auth/send-otp`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        email: targetValue, // API accepts phone number in the 'email' field
        type: "registration"
      })
    });

    if (res.ok) {
      // Save which input we are verifying so verifyCode uses the right one
      signupState.input = targetValue;
      switchToStep(4);
    } else {
      const err = await res.json();
      const msg = err.message || "Failed to send OTP.";
      if (methodErrorEl) methodErrorEl.textContent = msg;
    }
  } catch (e) {
    if (methodErrorEl) methodErrorEl.textContent = "Error sending code.";
  } finally {
    hideLoader();
    const btn = document.getElementById('send-code-btn');
    setButtonLoading(btn, false);
  }
}

// --- UPDATED VERIFY OTP (Based on your Postman discovery) ---
async function verifyCode() {
  // Prefer the visible OTP group for the current flow
  const stepSelector = window.isEliteFlow ? '#elite-step-4' : '#step-4';
  const container = document.querySelector(`${stepSelector} .code-input-group`) || document.querySelector('.code-input-group');
  const inputs = container ? container.querySelectorAll('input') : document.querySelectorAll('.code-input-group input');
  const token = Array.from(inputs)
    .map(input => input.dataset.digit || '')
    .join('');

  // Choose correct error container (Elite vs base)
  const errorEl = document.getElementById(window.isEliteFlow ? 'elite-otp-error' : 'otp-error');
  if (errorEl) errorEl.textContent = '';

  if (token.length !== 4) {
    if (errorEl) {
      errorEl.textContent = 'Please enter the complete 4-digit code.';
    }
    return;
  }

  showLoader();
  const btn = document.getElementById(window.isEliteFlow ? 'elite-otp-continue' : 'otp-continue-btn');
  setButtonLoading(btn, true);

  try {
    const accessToken = await getAccessToken();

    const response = await fetch(`${base_url}/api/shopify-auth/verify-otp`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        otp: token,
        email: signupState.input
      })
    });

    const data = await response.json();

    if (data.success || response.ok) {
      console.log('OTP verified successfully');
      signupState.otpToken = token;

      // FIX: Changed from 4 to 5 to move to the Password Step
      switchToStep(5);
    } else {
      const message = data.message || 'Invalid code. Please try again.';
      if (errorEl) {
        errorEl.textContent = message;
      }
    }
  } catch (error) {
    console.error('Error during OTP verification:', error);
    if (errorEl) {
      errorEl.textContent = 'Network error. Please try again.';
    }
  } finally {
    hideLoader();
    const btn = document.getElementById(window.isEliteFlow ? 'elite-otp-continue' : 'otp-continue-btn');
    setButtonLoading(btn, false);
  }
}


async function finishSignup() {
  const password = document.getElementById('password').value;
  const confirmPassword = document.getElementById('confirmPassword').value;

  // Inline error container (normal vs Elite flow)
  const errorEl = document.getElementById(window.isEliteFlow ? 'elite-signup-error' : 'signup-error');
  if (errorEl) errorEl.textContent = '';
  const btn = document.getElementById(window.isEliteFlow ? 'elite-signup-btn' : 'signupBtn');

  if (password.length < 6) {
    const msg = "Password must be at least 6 characters.";
    if (errorEl) errorEl.textContent = msg;
    return;
  }

  if (password !== confirmPassword) {
    const msg = "Passwords do not match.";
    if (errorEl) errorEl.textContent = msg;
    return;
  }

  showLoader();
  setButtonLoading(btn, true);

  try {
    const accessToken = await getAccessToken();

    const redirectUrl = window.isEliteFlow
      ? 'https://cannacabana.com/pages/elite'
      : 'https://cannacabana.com/account';

    const payload = {
      first_name: signupState.firstName,
      last_name: signupState.lastName,
      email: signupState.email,
      phone_number: signupState.phone,
      postal_code: signupState.postalCode,
      date_of_birth: signupState.dob,
      password: password,
      password_confirmation: password,
      token: signupState.otpToken,
      favoriteStoreName: "Cochrane",
      redirectUrl: redirectUrl
    };

    const res = await fetch(`${base_url}/api/shopify-auth/register`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const result = await res.json();

    if (res.ok && result.data && result.data.returnUrl) {
      console.log('Registration successful. Showing success screen...');

      // 1. Move to Step 6 immediately
      document.getElementById('success-name').textContent = signupState.firstName;
      switchToStep(6);
      // Keep the success step visible while we redirect. Do not auto-close the popup.
      try {
        const successBtn = document.getElementById('success-continue-btn');
        if (successBtn) {
          // Disable + show spinner-in-button to prevent clicks while redirecting
          setButtonLoading(successBtn, true);
        }
      } catch (_) { }
      hideLoader(); // success step has its own spinner, keep overlay hidden

      // 2. Wait 3 seconds so they can read "Success!", then redirect
      setTimeout(() => {
        if (window.isEliteFlow) {
          sessionStorage.setItem('elite_redirect_after_login', 'https://cannacabana.com/pages/elite');
          sessionStorage.setItem('elite_login_open_popup', '1');
        }
        window.location.href = result.data.returnUrl;
      }, 2000);

      return;
    }

    if (res.ok) {
      // Fallback if no return URL
      document.getElementById('success-name').textContent = signupState.firstName;
      switchToStep(6);
    } else {
      let errorMsg = "Registration failed.";
      if (result.error) {
        if (typeof result.error === 'string') {
          errorMsg = result.error;
        } else if (typeof result.error === 'object') {
          // Join all API error messages (e.g. { phone: 'Phone is invalid' })
          errorMsg = Object.values(result.error).join(' ');
        }
      } else if (result.message) {
        errorMsg = result.message;
      }

      if (errorMsg && errorEl) {
        errorEl.textContent = errorMsg;
      }
    }
  } catch (e) {
    console.error("Signup error:", e);
    const msg = "An error occurred during account creation.";
    if (errorEl) errorEl.textContent = msg;
  } finally {
    // Only hide loader if we aren't already on the success screen
    const currentStep = document.getElementById('step-6');
    if (currentStep.style.display !== 'block') {
      hideLoader();
    }
    setButtonLoading(btn, false);
  }
}


async function loginToShopify(email, password) {
  try {
    const formData = new FormData();
    formData.append('customer[email]', email);
    formData.append('customer[password]', password);
    formData.append('form_type', 'customer_login');

    await fetch('/account/login', {
      method: 'POST',
      body: formData
    });

    // Update Success UI
    const nameEl = document.querySelector('#step-5 strong');
    if (nameEl) nameEl.textContent = email;

    switchToStep(5);
  } catch (err) {
    switchToStep(5);
  }
}


function continueShopping() {
  window.location.href = '/collections/all';
}

// Success step button: keep modal open; redirect is handled automatically after success.
document.addEventListener('DOMContentLoaded', function () {
  const successBtn = document.getElementById('success-continue-btn');
  if (!successBtn) return;
  successBtn.addEventListener('click', function (e) {
    e.preventDefault();
    // No-op: we intentionally keep the popup visible until redirect.
  });
});

function moveToNext(current, index) {
  const inputs = document.querySelectorAll('.code-input-group input');
  if (current.value && index < inputs.length) {
    inputs[index].focus();
  }
  handleCodeInput();
}

function handleCodeInput() {
  const inputs = document.querySelectorAll('.code-input-group input');
  const code = Array.from(inputs).map(input => input.value).join('');
  const continueButton = document.querySelector('#step-3 .cabana-btn');

  if (code.length === 4 && /^\d{4}$/.test(code)) {
    continueButton.disabled = false;
    continueButton.classList.remove('disabled');
  } else {
    continueButton.disabled = true;
    continueButton.classList.add('disabled');
  }
}

function validatePassword() {
  const password = document.getElementById('password')?.value || '';
  const confirm = document.getElementById('confirmPassword')?.value || '';
  const termsCheckbox = document.getElementById('accept-terms');
  const signupBtn = document.getElementById('signupBtn');

  if (!signupBtn) return;

  const isPasswordValid = password.length >= 6;
  const passwordsMatch = password === confirm && password !== '';
  const isTermsAccepted = termsCheckbox ? termsCheckbox.checked : false;

  // The button should only be active if all 3 conditions are met
  if (isPasswordValid && passwordsMatch && isTermsAccepted) {
    signupBtn.disabled = false;
    signupBtn.classList.remove('disabled');
  } else {
    signupBtn.disabled = true;
    signupBtn.classList.add('disabled');
  }
}

function togglePassword(fieldId, btn) {
  const field = document.getElementById(fieldId);
  const isPassword = field.type === 'password';
  field.type = isPassword ? 'text' : 'password';

  const icon = btn.querySelector('img');
  const label = btn.querySelector('span');

  if (isPassword) {
    icon.src = "https://cdn-icons-png.flaticon.com/512/709/709612.png";
    label.textContent = "Hide";
  } else {
    icon.src = "https://cdn-icons-png.flaticon.com/512/565/565655.png";
    label.textContent = "Show";
  }
}

function showLoader() {
  const loader = document.getElementById('cabana-loader');
  if (loader) loader.style.display = 'flex';
}

function hideLoader() {
  const loader = document.getElementById('cabana-loader');
  if (loader) loader.style.display = 'none';
}

function displayError(id, msg) {
  const el = document.getElementById(id);
  if (el) el.textContent = msg;
}

function clearError(id) {
  const el = document.getElementById(id);
  if (el) el.textContent = '';
}

let resendTimer;

async function sendOTP(email) {
  showLoader();
  try {
    const accessToken = await getAccessToken();

    const response = await fetch(`${base_url}/api/shopify-auth/send-otp`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email: email }),
    });

    const result = await response.json();
    console.log("OTP sent response:", result);

    if (response.ok || result.success) {
      // For initial send (from recovery / non-OTP screens), go to channel selection.
      // For resend from the OTP step, we stay on the same screen and only show a success message.
      const fromResend = !!sendOTP._fromResend;
      if (!fromResend) {
        switchToStep(3);
      }
      startResendCountdown();
      const successEl = document.getElementById(window.isEliteFlow ? 'elite-otp-error' : 'otp-error');
      if (successEl) {
        successEl.style.textAlign = 'center';
        successEl.innerHTML = `
          <span class="otp-success-message">
            <span class="login-recover-success__icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span>A new code has been sent.</span>
          </span>
        `;
      }
    } else {
      const msg = result.message || "Failed to send code.";
      const errorEl = document.getElementById(window.isEliteFlow ? 'elite-otp-error' : 'otp-error');
      if (errorEl) {
        errorEl.textContent = msg;
      }
    }

  } catch (err) {
    console.error("Failed to send OTP", err);
    const errorEl = document.getElementById(window.isEliteFlow ? 'elite-otp-error' : 'otp-error');
    if (errorEl) {
      errorEl.textContent = "Error sending OTP. Please try again.";
    }
  } finally {
    hideLoader();
  }
}


function resendCode(e) {
  if (e) e.preventDefault();
  const email = signupState.input; // Use saved state
  if (!email) {
    const errorEl = document.getElementById(window.isEliteFlow ? 'elite-otp-error' : 'otp-error');
    if (errorEl) {
      errorEl.textContent = "Email not found. Go back and enter a valid email.";
    }
    return;
  }

  const resendLink = document.querySelector('.resend-link a');
  if (resendLink.classList.contains("disabled")) return;

  // Flag resend so sendOTP knows not to jump back to channel selection
  sendOTP._fromResend = true;
  sendOTP(email).finally(() => {
    sendOTP._fromResend = false;
  });
}


function startResendCountdown() {
  const resendLink = document.querySelector('.resend-link a');
  let seconds = 60;
  resendLink.classList.add("disabled");
  resendLink.style.pointerEvents = "none";

  resendLink.textContent = `Resend available in ${seconds}s`;

  resendTimer = setInterval(() => {
    seconds--;
    if (seconds <= 0) {
      clearInterval(resendTimer);
      resendLink.textContent = "Resend Code";
      resendLink.style.pointerEvents = "auto";
      resendLink.classList.remove("disabled");
    } else {
      resendLink.textContent = `Resend available in ${seconds}s`;
    }
  }, 1000);
}

document.querySelector('[data-customer-signup-trigger]')?.addEventListener('click', function (e) {
  e.preventDefault(); // Prevent link default
  openCabanaPopup();
});

document.querySelector('[data-customer-mobile-signup-trigger]')?.addEventListener('click', function (e) {
  e.preventDefault(); // Prevent link default
  openCabanaPopup();
});

// Restrict phone number inputs to exactly 10 digits and numbers only
document.addEventListener('input', function (e) {
  if (e.target && (e.target.id === 'reg-phone' || e.target.id === 'elite-reg-phone')) {
    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
  }
});